import React from 'react';

import { Link } from 'components/elems';
import { UserLoginForm } from 'components/forms';


// TODO: Header opacity, rhs icon, footer position in small screen..

const PunchyCopyAboveLoginForm = () => (
  <div className="tc">
    <div className="moa-ff-argent near-black f1 fw4 mb4">
      Moagraph
    </div>
  </div>
);


const StuffBelowLoginForm = () => (
  <div className="black-50 f6 mt4 tr">
    <span className="mr2">
      Don't have an account?
    </span>
    <Link type="accented" to="/signup">Sign up</Link>
  </div>
);

const Login = () => (
  <div className="moa-ff-sans min-vh-100 pt5 ph3 ph5-ns mw6 center">
    <div className="mt3 pt5">
      <UserLoginForm
        copyAboveLoginForm={<PunchyCopyAboveLoginForm />}
        stuffBelowLoginForm={<StuffBelowLoginForm />}
      />
    </div>
  </div>
);


export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js